import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text" }, " Выберите тип данных и конкретный тест/группу/отдел/сотрудника/интервал дат для получения статистики по этим данным: ", -1)
const _hoisted_2 = { class: "select-picker" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sticky-table__cell__separator" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "inside-text"
}
const _hoisted_5 = {
  key: 2,
  class: "inside-text-wrapper"
}
const _hoisted_6 = { class: "inside-text" }

import AdminApi from "@/api/AdminApi";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsTabComponent',
  setup(__props) {

const api = new AdminApi();
const stats = ref([]);
const specificOptions = ref([]);
const backupOptions = ref([]);
const data = [
  "Тест",
  "Группа вопросов",
  "Дата прохождения",
  "Тест (детально)",
  "Отдел",
  "Сотрудник",
];
const selectedSpecificOption = ref();
const selectedData = ref();
const selectedSpecificatorText = ref("Нет результатов");
let excelContent = "";
let excelFilename = "";
const accessToExcelStatistic = ref(false);
const tableRef = ref();
const loading = ref(false);
const pagination = ref({
  descending: false,
  page: 1,
  rowsPerPage: 7,
});

const columns = ref([
  {
    name: "attempDate",
    required: true,
    label: "Дата прохождения",
    align: "left",
    field: (row: { attempDate: string }) =>
      new Date(row.attempDate).toLocaleDateString(),
    format: (val: any) => `${val}`,
    style: "width: 180px;",
    sortable: true,
  },
  {
    name: "userName",
    align: "left",
    label: "Пользователь",
    field: "userName",
    format: (val: any) => `${val}`,
    sortable: false,
  },
  {
    name: "percentageUser",
    align: "left",
    label: "Правильных ответов (%)",
    field: (row: { percentageUser: string }) =>
      Number(row.percentageUser).toFixed(1),
    format: (val: any) => `${val}`,
    style: "width: 200px;",
    sortable: true,
  },
  {
    name: "resultString",
    align: "left",
    label: "Рейтинг",
    field: "resultString",
    format: (val: any) => `${val}`,
    sortable: true,
  },
]);

function getOptionValue(): any {
  if (
    selectedData.value === "Тест" ||
    selectedData.value === "Группа вопросов" ||
    selectedData.value === "Тест (детально)"
  ) {
    return "id";
  } else if (selectedData.value === "Сотрудник") {
    return "userId";
  } else if (selectedData.value === "Отдел") {
    return (item: string) => item;
  } else {
    return "";
  }
}

function getOptionLabel(): any {
  if (
    selectedData.value === "Тест" ||
    selectedData.value === "Группа вопросов" ||
    selectedData.value === "Тест (детально)"
  ) {
    return "name";
  } else if (selectedData.value === "Сотрудник") {
    return (item: any) =>
      item.firstName === undefined ? "" : `${item.lastName} ${item.firstName}`;
  } else if (selectedData.value === "Отдел") {
    return (item: string) => item;
  } else {
    return "";
  }
}

function filterFn(val: any, update: any) {
  if (selectedData.value === "Сотрудник") {
    if (val === "") {
      update(() => {
        specificOptions.value = backupOptions.value;
      });
      return;
    }

    update(() => {
      const needle = val.toLowerCase();

      specificOptions.value = backupOptions.value.filter(function (elem) {
        return (
          elem.firstName.toLowerCase().indexOf(needle) > -1 ||
          elem.lastName.toLowerCase().indexOf(needle) > -1
        );
      });
    });
  } else {
    update(() => {
      return;
    });
  }
}

function downloadReport() {
  const url = window.URL.createObjectURL(new Blob([excelContent]));
  const link = document.createElement("a");
  link.setAttribute("download", excelFilename);
  link.setAttribute("href", url);
  document.body.appendChild(link);
  link.click();
  link.remove();
}

async function getDataTypes() {
  selectedSpecificOption.value = "";
  accessToExcelStatistic.value = false;
  specificOptions.value = [];
  selectedSpecificatorText.value = "Загружаются данные...";

  if (
    selectedData.value === "Тест" ||
    selectedData.value === "Тест (детально)"
  ) {
    await api
      .loadTests()
      .then((res) => {
        specificOptions.value = res;
      })
      .then(() => {
        selectedSpecificatorText.value = "Нет данных";
      });
  } else if (selectedData.value === "Группа вопросов") {
    await api
      .loadQuestionGroups()
      .then((res) => {
        specificOptions.value = res;
      })
      .then(() => {
        selectedSpecificatorText.value = "Нет данных";
      });
  } else if (selectedData.value === "Сотрудник") {
    await api
      .loadUsers()
      .then((res) => {
        specificOptions.value = res;
        backupOptions.value = res;
      })
      .then(() => {
        selectedSpecificatorText.value = "Нет данных";
      });
  } else if (selectedData.value === "Отдел") {
    await api
      .loadDepartments()
      .then((res) => {
        specificOptions.value = res;
      })
      .then(() => {
        selectedSpecificatorText.value = "Нет данных";
      });
  }
}

async function getStatistics() {
  loading.value = true;

  if (selectedData.value === "Дата прохождения") {
    await api
      .loadStatisticsByDate(
        selectedSpecificOption.value.from,
        selectedSpecificOption.value.to
      )
      .then((res) => {
        if (columns.value.length === 4) {
          columns.value.push({
            name: "testName",
            align: "left",
            label: "Название теста",
            field: "testName",
            format: (val: any) => `${val}`,
            sortable: false,
          });
        }
        stats.value = res;
        loading.value = false;
      });
  } else if (selectedData.value === "Тест") {
    await api
      .loadStatisticsByTestId(selectedSpecificOption.value.id)
      .then((res) => {
        if (columns.value.length === 5) {
          columns.value.pop();
        }
        stats.value = res;
        loading.value = false;
      });
  } else if (selectedData.value === "Группа вопросов") {
    await api
      .loadStatisticsByGroupId(selectedSpecificOption.value.questionGroupId)
      .then((res) => {
        if (columns.value.length === 4) {
          columns.value.push({
            name: "testName",
            align: "left",
            label: "Название теста",
            field: "testName",
            format: (val: any) => `${val}`,
            sortable: false,
          });
        }
        stats.value = res;
        loading.value = false;
      });
  } else if (selectedData.value === "Тест (детально)") {
    await api
      .loadStatisticByTestDetails(selectedSpecificOption.value.id)
      .then((res) => {
        excelContent = res;
        excelFilename =
          "Детальный отчет по тесту '" +
          selectedSpecificOption.value.name +
          "' от " +
          new Date().toLocaleDateString() +
          ".xlsx";
        accessToExcelStatistic.value = true;
      });
  } else if (selectedData.value === "Отдел") {
    await api
      .loadStatisticByDepartment(selectedSpecificOption.value)
      .then((res) => {
        excelContent = res;
        excelFilename =
          "Отчет по отделу '" +
          selectedSpecificOption.value +
          "' от " +
          new Date().toLocaleDateString() +
          ".xlsx";
        accessToExcelStatistic.value = true;
      });
  } else if (selectedData.value === "Сотрудник") {
    await api
      .loadStatisticByUser(selectedSpecificOption.value.azureId)
      .then((res) => {
        excelContent = res;
        excelFilename =
          "Отчет по сотруднику " +
          selectedSpecificOption.value.lastName +
          " " +
          selectedSpecificOption.value.firstName +
          " от " +
          new Date().toLocaleDateString() +
          ".xlsx";
        accessToExcelStatistic.value = true;
      });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_select, {
        outlined: "",
        class: "select-picker__select",
        modelValue: selectedData.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedData).value = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (getDataTypes()))
        ],
        label: "Тип данных",
        options: data
      }, null, 8, ["modelValue"]),
      (selectedData.value === 'Дата прохождения')
        ? (_openBlock(), _createBlock(_component_q_date, {
            key: 0,
            modelValue: selectedSpecificOption.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSpecificOption).value = $event)),
            class: "select-picker__select",
            minimal: "",
            range: "",
            onRangeEnd: _cache[3] || (_cache[3] = ($event: any) => (getStatistics())),
            mask: "YYYY-MM-DDTHH:mm:ss",
            locale: {
        days: [
          'Воскресенье',
          'Понедельник',
          'Вторник',
          'Среда',
          'Четверг',
          'Пятница',
          'Суббота',
        ],
        daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь',
        ],
        monthsShort: [
          'Янв',
          'Фев',
          'Мар',
          'Апр',
          'Май',
          'Июн',
          'Июл',
          'Авг',
          'Сен',
          'Окт',
          'Ноя',
          'Дек',
        ],
      }
          }, null, 8, ["modelValue"]))
        : (_openBlock(), _createBlock(_component_q_select, {
            key: 1,
            outlined: "",
            class: "select-picker__select",
            modelValue: selectedSpecificOption.value,
            "onUpdate:modelValue": [
              _cache[4] || (_cache[4] = ($event: any) => ((selectedSpecificOption).value = $event)),
              _cache[5] || (_cache[5] = ($event: any) => (getStatistics()))
            ],
            "use-input": selectedData.value === 'Сотрудник',
            onFilter: filterFn,
            label: selectedData.value === undefined ? '' : 'Выберите ' + selectedData.value,
            options: specificOptions.value,
            disable: !selectedData.value,
            "option-value": getOptionValue(),
            "option-label": getOptionLabel()
          }, {
            "no-option": _withCtx(() => [
              _createVNode(_component_q_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, { class: "text-grey" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(selectedSpecificatorText.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "use-input", "label", "options", "disable", "option-value", "option-label"]))
    ]),
    (
      stats.value.length > 0 &&
      (selectedData.value === 'Дата прохождения' ||
        selectedData.value === 'Тест' ||
        selectedData.value === 'Группа вопросов') &&
      selectedSpecificOption.value != ''
    )
      ? (_openBlock(), _createBlock(_component_q_table, {
          key: 0,
          class: "sticky-table",
          flat: "",
          ref_key: "tableRef",
          ref: tableRef,
          title: "",
          rows: stats.value,
          columns: columns.value,
          loading: loading.value,
          "row-key": "userId",
          pagination: pagination.value,
          "onUpdate:pagination": _cache[6] || (_cache[6] = ($event: any) => ((pagination).value = $event))
        }, {
          "body-cell": _withCtx((props) => [
            _createVNode(_component_q_td, {
              class: "sticky-table__cell",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.value) + " ", 1),
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "columns", "loading", "pagination"]))
      : (
      selectedData.value != '' &&
      selectedData.value != undefined &&
      selectedSpecificOption.value != '' &&
      selectedSpecificOption.value != undefined &&
      stats.value.length === 0 &&
      selectedData.value != 'Тест (детально)' &&
      selectedData.value != 'Отдел' &&
      selectedData.value != 'Сотрудник'
    )
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " По этой " + _toDisplayString(selectedData.value) + " еще нет статистики ", 1))
        : (accessToExcelStatistic.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, " Этот отчет по \"" + _toDisplayString(selectedData.value) + "\" доступен только для скачивания в Excel. Нажмите кнопку, чтобы скачать его ", 1),
              _createElementVNode("button", {
                class: "base-btn base-btn-yellow",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (downloadReport()))
              }, " Скачать отчет ")
            ]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})